import clsx from 'clsx';

import CheckIcon from '@/components/icons/check';
import CloseSmallIcon from '@/components/icons/close-small';

export interface IPasswordValidation {
  hasLowercase: boolean;
  hasUppercase: boolean;
  hasNumber: boolean;
  hasMinLength: boolean;
}

type PasswordValidationKeys = keyof IPasswordValidation;

function PasswordValidationsList(passwordValidationsList: IPasswordValidation) {
  const passwordValidationsListMessages: Record<PasswordValidationKeys, string> = {
    hasLowercase: 'One lowercase character',
    hasUppercase: 'One uppercase character',
    hasNumber: 'One number',
    hasMinLength: '10 characters minimum',
  };

  return (
    <div>
      <p className="text-secondary-text block pt-3 text-xs">Passwords must contain:</p>

      {Object.keys(passwordValidationsList).map((key) => (
        <p
          key={key}
          className={clsx('flex items-center text-xs', passwordValidationsList[key as PasswordValidationKeys] ? 'text-default-green' : 'text-secondary-text')}>
          {!passwordValidationsList[key as PasswordValidationKeys] && <CloseSmallIcon />}
          {passwordValidationsList[key as PasswordValidationKeys] && <CheckIcon />}
          {passwordValidationsListMessages[key as PasswordValidationKeys]}
        </p>
      ))}
    </div>
  );
}

export { PasswordValidationsList };
